import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { HiddenInput, ButtonLabel } from "./primitives";

var ButtonGroupOption = function ButtonGroupOption(_ref) {
  var id = _ref.id,
      name = _ref.name,
      label = _ref.label,
      value = _ref.value,
      _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'base' : _ref$size,
      totalOptions = _ref.totalOptions,
      onChange = _ref.onChange,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      clicked = _useState2[0],
      setClicked = _useState2[1];

  var handleLabelClick = function handleLabelClick() {
    setClicked(true);
  };

  var handleInputFocus = function handleInputFocus(event) {
    if (clicked) {
      setClicked(false);
      event.target.blur();
    }
  };

  var handleChange = function handleChange(event) {
    if (!disabled) {
      onChange(event.target.value);
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HiddenInput, {
    type: "radio",
    id: id,
    name: name,
    value: value,
    checked: checked,
    onChange: handleChange,
    onFocus: handleInputFocus,
    disabled: disabled,
    variant: variant
  }), /*#__PURE__*/React.createElement(ButtonLabel, {
    htmlFor: id,
    name: name,
    onClick: handleLabelClick,
    size: size,
    totalOptions: totalOptions,
    value: value,
    variant: variant
  }, label));
};

ButtonGroupOption.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  value: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.array]),
  totalOptions: PropTypes.number.isRequired,
  variant: PropTypes.string
};
export default ButtonGroupOption;